import React from "react";
import { observer, inject } from "mobx-react";
import orderBy from "lodash/orderBy";
import { withRouter, Link } from "react-router-dom";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import { graphql } from "react-apollo";
import { RATING_TABLE_QUERY } from "Services/queries";
import { generateUrl } from "Services/withDefaultParams";
import { sendMetriks } from "Services/sendMetriks";
import withDefaultParams from "Services/withDefaultParams";
import Metrika from "Services/Metrika";
import { EVENT_CATEGORY_ORDER } from "Constants/metriks/GoogleCategorys";
import { ACTION_OTZIV_OK } from "Constants/metriks/GoogleActions";
import Routes from "Configs/routes";
import { getDeclinationV2 } from "Utils/text";
import ProviderConnectWithPhoneHOC from "HOC/ProviderConnectWithPhoneHOC";
import ratingFullText from "Texts/rating";
import TableRating from "Layouts/RatingTableLayout/TableRating";
import { Col } from "ComponentsUI/Styles/Grid";
import { EmptyStub } from "ComponentsUI/EmptyStub";
import { ModalLayout } from "ComponentsUI/Modallayout";
import {
    RowRating,
    BodyRating,
    HeaderRowRating,
    ButtonsRowRating,
} from "ComponentsUI/RatingTableNew";
import Button from "ComponentsUI/Button";
import Block from "ComponentsUI/Block";

@inject("ApplicationModel")
@observer
class RatingTableContainer extends React.Component {
    onClickHowCalculateRating() {
        let modalModel = this.props.ApplicationModel.modalModel;
        const text = this.props.ApplicationModel.text;
        let windowSizeModel = this.props.ApplicationModel.windowSizeModel;
        import("ComponentsUI/News").then(News => {
            let FullNewsItem = News.FullNewsItem;
            modalModel.toggleModal(
                <ModalLayout
                    closeModal={() => this.closeModal()}
                    newsView={true}
                    fullCloseElement={true}
                    onlyDesktopCloseElement={true}
                    closeOnClickLayout={true}
                >
                    <FullNewsItem
                        toggleWindow={() => this.closeModal()}
                        windowSizes={windowSizeModel.windowSizes}
                        typeB={true}
                        texts={text}
                        name={text.HOW_WE_CALCULATE_RATING}
                        full_text={ratingFullText}
                    />
                </ModalLayout>,
            );
        });
    }

    onClickRating() {
    }

    closeModal() {
        let modalModel = this.props.ApplicationModel.modalModel;
        modalModel.toggleModal();
    }

    onClickReviewHandler() {
        Metrika.getInstance().google.sendEvent(
            EVENT_CATEGORY_ORDER,
            ACTION_OTZIV_OK,
        );
    }

    onClickButtonHandler() {
        this.props.ApplicationModel.providerModel.setProviderFeedback(
            this.props.match.params.providerName,
        );
    }

    render() {
        if (!this.props.data) {
            return null;
        }
        if (!this.props.data.providers) return null;
        let providers = [];
        let ratingUrl = generateUrl(Routes.Rating.route, {
            regionUrl: this.props.match.params.regionUrl,
        });
        let addReviewUrl = generateUrl(Routes.AddReview.route, {
            regionUrl: this.props.match.params.regionUrl,
        });

        this.props.data.providers.data.forEach((item, index) => {
            let finded = item.rating.order_types.find(
                o => o.order_type_id === 1,
            );
            if (!finded) return;
            let linkCard = generateUrl(Routes.ProviderDetails.route, {
                regionUrl: this.props.match.params.regionUrl,
                providerName: item.url_name,
            });
            let linkRates = generateUrl(Routes.ProviderRates.route, {
                regionUrl: this.props.match.params.regionUrl,
                providerName: item.url_name,
            });
            providers.push({
                id: item.id,
                name: item.name,
                logo: item.logo,
                tariffCount: item.info.cnt_tariffs,
                rating: (Math.round(finded.rating, 0) * 0.1).toFixed(1),
                reviews: finded.review_all,
                positive: finded.rating_plus,
                negative: finded.rating_minus,
                neutral: finded.rating_middle,
                comments: finded.provider_answer_count,
                linkToProvider: linkCard,
                linkRates: linkRates,
            });
        });
        providers = orderBy(providers, ["rating"], "desc");
        providers.forEach((provider, i) => {
            provider.pos = ++i;
        });
        let first_10 = providers.slice(0, 10);
        // let last_5 = providers.slice(-5);

        let emotion = {
            negative: require("icons/sad.png"),
            positive: require("icons/smile.png"),
            neutral: require("icons/frown.png"),
            handshake: require("icons/handshake.png"),
            bubble: require("icons/bubble.png"),
        };
        let text = this.props.ApplicationModel.text;
        let feedbackUrl = generateUrl(Routes.AddReview.route, {
            regionUrl: this.props.match.params.regionUrl,
        });
        return (
            <Block
                header={text.rating}
                noButton={true}
                datatest="main_rating_subscribe_callback"
            >
                <Container>
                    <Row>
                        <Col>
                            <TableRating>
                                <HeaderRowRating
                                    mainPage={true}
                                    text={text}
                                    pos={"№"}
                                    name={text.filtersProvider}
                                    TariffName={text.menuRates}
                                    ratingName={text.menuRating}
                                    ratingCount={text.FROM_10}
                                    positive={
                                        <img
                                            alt={"positive"}
                                            src={emotion.positive}
                                        />
                                    }
                                    neutral={
                                        <img
                                            alt={"neutral"}
                                            src={emotion.neutral}
                                        />
                                    }
                                    negative={
                                        <img
                                            alt={"negative"}
                                            src={emotion.negative}
                                        />
                                    }
                                    reviews={
                                        <img
                                            alt={"reviews"}
                                            src={emotion.handshake}
                                        />
                                    }
                                    comments={
                                        <img
                                            alt={"comments"}
                                            src={emotion.bubble}
                                        />
                                    }
                                />
                                <BodyRating>
                                    {first_10.map(provider => {
                                        return (
                                            <RowRating
                                                mainPage={true}
                                                key={provider.pos}
                                                pos={provider.pos}
                                                logo={provider.logo}
                                                providerName={provider.name}
                                                name={
                                                    <Link
                                                        to={
                                                            provider.linkToProvider
                                                        }
                                                    >
                                                        {provider.name}
                                                    </Link>
                                                }
                                                tariffLink={
                                                    <Link
                                                        to={
                                                            provider.linkRates
                                                        }
                                                    >
                                                        {getDeclinationV2(provider.tariffCount, [text.TARIFFS_4, text.TARIFFS_5, text.TARIFFS_3])}
                                                    </Link>
                                                }
                                                button={
                                                    <ProviderConnectWithPhoneHOC ratingClick={true} providerId={provider.id}>
                                                        <Button
                                                            fullWidth={true}
                                                            datatest="main_form_ratingTable_waitcall_button"
                                                            status={"purple"}
                                                            size={"low"}
                                                            // onClick={() =>
                                                            //     this.onClickButtonWaitCall()
                                                            // }
                                                        >
                                                            {text.connect}
                                                        </Button>
                                                    </ProviderConnectWithPhoneHOC>
                                                }
                                                tariffCount={provider.tariffCount}
                                                rating={provider.rating}
                                                positive={provider.positive}
                                                neutral={provider.neutral}
                                                negative={provider.negative}
                                                reviews={provider.reviews}
                                                comments={provider.comments}
                                                noInformation={
                                                    text.NO_INFORMATION
                                                }
                                            />
                                        );
                                    })}
                                </BodyRating>
                                <ButtonsRowRating
                                    datatestHowTo="main_pop_up_button"
                                    howTo={text.ratingBelieveTheRating}
                                    onClick={() =>
                                        this.onClickHowCalculateRating()
                                    }
                                    firstButton={
                                        <Button
                                            component={
                                                <Link
                                                    to={
                                                        !!addReviewUrl
                                                            ? addReviewUrl
                                                            : "/"
                                                    }
                                                />
                                            }
                                            status={"tertiaryAccent"}
                                            size={"middle"}
                                            datatest="main_writereviews_button"
                                            onClick={() =>
                                                this.onClickReviewHandler()
                                            }
                                        >
                                            {text.ratingLeaveReview}
                                        </Button>
                                    }
                                    secondButton={
                                        <Button
                                            component={
                                                <Link
                                                    to={
                                                        !!ratingUrl
                                                            ? ratingUrl
                                                            : "/"
                                                    }
                                                />
                                            }
                                            status={"tertiaryAccent"}
                                            size={"middle"}
                                            datatest="main_allrating_button"
                                            onClick={() => this.onClickRating()}
                                        >
                                            {text.ratingAll}
                                        </Button>
                                    }
                                />
                            </TableRating>
                            {providers.length === 0 && (
                                <Row>
                                    <Col
                                        lg={{ size: 4, offset: 4 }}
                                        md={{ size: 4, offset: 4 }}
                                        sm={{ size: 4, offset: 4 }}
                                        xs={{ size: 6, offset: 3 }}
                                    >
                                        <EmptyStub
                                            header={text.NO_PROVIDERS_HEADER}
                                            text={text.NO_PROVIDERS_TEXT}
                                            icon={
                                                <span
                                                    className="icon48 icon-balance"
                                                    style={{
                                                        fontSize: "48px",
                                                        color: "#5812fe",
                                                    }}
                                                />
                                            }
                                            button={
                                                <Button
                                                    stub={false}
                                                    typeText="big"
                                                    component={
                                                        <Link
                                                            to={
                                                                !!feedbackUrl
                                                                    ? feedbackUrl
                                                                    : "/"
                                                            }
                                                        />
                                                    }
                                                    size={"middle"}
                                                    status={"purple"}
                                                    datatest="main_ratingLeaveReview_button"
                                                    fullWidth={true}
                                                    onClick={() =>
                                                        this.onClickButtonHandler()
                                                    }
                                                >
                                                    {text.ratingLeaveReview}
                                                </Button>
                                            }
                                        />
                                    </Col>
                                </Row>
                            )}
                        </Col>
                        {/*<Col lg={4} md={12} sm={12} xs={12}>*/}
                        {/*    <Row>*/}
                        {/*        <Col lg={12} md={6} sm={6} xs={12}>*/}
                        {/*            <CallbackConteiner />*/}
                        {/*        </Col>*/}
                        {/*        /!*<Col lg={12} md={6} sm={6} xs={12}>*!/*/}
                        {/*        /!*    <SubscribeConteiner />*!/*/}
                        {/*        /!*</Col>*!/*/}
                        {/*    </Row>*/}
                        {/*</Col>*/}
                    </Row>
                </Container>
            </Block>
        );
    }
}

export default withRouter(
    withDefaultParams(
        graphql(RATING_TABLE_QUERY, {
            skip: ownProps => {
                return ownProps.match.params.regionUrl ? false : true;
            },
            options: props => {
                let filter = [];
                let variables = {};
                if (props.match.params.regionUrl) {
                    filter.push(`region.url=${props.match.params.regionUrl}`);
                    variables.filter = `region.url=${props.match.params.regionUrl}`;
                    variables.urlName = props.match.params.regionUrl;
                    variables.filterRegion = `url=${props.match.params.regionUrl}`;
                }
                return {
                    variables: {
                        ...variables,
                        inMainRating: 1,
                    },
                };
            },
        })(RatingTableContainer),
    ),
);
